import React, { Fragment } from "react";
import { useUniqueId } from "shared/uniqueId/useUniqueId";
import { Attribute } from "api/types/attribute";
import { SiteSurveyUnitAttribute } from "api/types/siteSurveyUnitAttribute";

interface RadioGroupType {
  attributeConfig: Attribute;
  attributeValue?: SiteSurveyUnitAttribute;
  onAttributeValueChange: (attributeValueText: string) => void;
}
export function RadioGroup({
  attributeConfig,
  attributeValue,
  onAttributeValueChange,
}: RadioGroupType) {
  const { uid } = useUniqueId("RadioGroup");

  function handleOnClick(e: React.ChangeEvent<HTMLInputElement>) {
    onAttributeValueChange(e.target.value);
  }

  return (
    <div className="mt-3">
      <label className="form-label">{attributeConfig.text}</label>
      <div className="d-block btn-group" role="group">
        {attributeConfig.choices.map((choice, index) => {
          return (
            <Fragment key={`choice-${index}-${choice.text}`}>
              <input
                type="radio"
                className="btn-check"
                name={uid(`choice`)}
                id={uid(`choice-${index}`)}
                autoComplete="off"
                value={choice.text ?? ""}
                onChange={handleOnClick}
                checked={attributeValue?.attributeValue === choice.text}
              />

              <label
                className="btn btn-outline-primary"
                htmlFor={uid(`choice-${index}`)}
              >
                {choice.text}
              </label>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
